// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsletterHeader_wrapper__zngoZ"};